<template>
  <section id="medium-posts" class="py-5" v-if="!error && posts.length > 0">
    <div class="container">
      <div class="row py-5">
        <div class="col-lg-12">
          <h2 class="title__section" data-aos="fade-up" data-aos-delay="100">
            Artigos
          </h2>
        </div>
      </div>
      <div class="posts-container">
        <a
          v-for="(post, index) in posts"
          :key="index"
          :href="post.link"
          target="_blank"
          rel="noopener noreferrer"
          class="post-card"
          data-aos="fade-up"
          :data-aos-delay="100 + index * 100"
          @click="trackClick(post)"
        >
          <div class="post-image" v-if="post.thumbnail">
            <img :src="post.thumbnail" :alt="post.title" />
          </div>
          <div class="post-content">
            <div class="post-categories">
              <span
                v-for="(category, catIndex) in post.categories.slice(0, 3)"
                :key="catIndex"
                class="category-tag"
              >
                {{ category }}
              </span>
            </div>
            <h3 class="post-title">{{ post.title }}</h3>
            <p class="post-date">{{ formatDate(post.pubDate) }}</p>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import mediumApi from "@/api/medium-api";
import mixpanel from "mixpanel-browser";

export default {
  name: "MediumPostsSection",
  data() {
    return {
      posts: [],
      loading: true,
      error: false,
    };
  },
  mounted() {
    this.fetchPosts();
  },
  methods: {
    async fetchPosts() {
      try {
        const response = await mediumApi.getPosts();
        if (response.status === "ok") {
          this.posts = response.items.map((item) => {
            // Extrai a primeira imagem do description se thumbnail estiver vazio
            if (!item.thumbnail) {
              const imgMatch = item.description.match(/<img[^>]+src="([^">]+)"/);
              if (imgMatch) {
                item.thumbnail = imgMatch[1];
              }
            }
            return item;
          });
        }
      } catch (err) {
        console.error("Erro ao carregar posts do Medium:", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    trackClick(post) {
      this.$gtag.event("click_medium_post", {
        event_category: "medium",
        event_label: post.title,
      });
      mixpanel.track("click", {
        nameOfButton: "Medium Post",
        postTitle: post.title,
      });
    },
  },
};
</script>

<style lang="css" scoped>
#medium-posts {
  background-color: #fafafa;
}

.posts-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: flex-start;
}

.post-card {
  display: flex;
  flex-direction: column;
  width: calc(33.333% - 16px);
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-decoration: none;
  color: inherit;
}

.post-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  color: inherit;
}

.post-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.post-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.post-card:hover .post-image img {
  transform: scale(1.05);
}

.post-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.post-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.category-tag {
  font-size: 0.7em;
  padding: 4px 10px;
  background-color: #f0f0f0;
  border-radius: 20px;
  color: #666;
  text-transform: lowercase;
}

.post-title {
  font-size: 1.1em;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 12px;
  color: #000;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.post-date {
  font-size: 0.85em;
  color: #888;
  margin-top: auto;
}

@media (max-width: 992px) {
  .post-card {
    width: calc(50% - 12px);
  }
}

@media (max-width: 576px) {
  .post-card {
    width: 100%;
  }
}
</style>
